module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-700-44bb1bc773b816dfb13a88f43d0d0476.ttf";